import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import ReactQuill from "react-quill";
import api from "../../api";
import Logo from "../../images/logo-2.png";
import add from "../../images/add.png";
import "react-quill/dist/quill.snow.css";
import { useSelector } from "react-redux";
import { useAlert } from "react-alert";

const INITIAL_TRADE = { currency: "", entryPrice: "", takeProfit: "", stopLoss: "", positionType: "Long", marginUsedUSDT: "", status: "Open", pnlUSDT: "", roiPercent: "" };

const autoPositionType = (entry, tp) => {
  const e = parseFloat(entry);
  const t = parseFloat(tp);
  if (!isNaN(e) && !isNaN(t) && e !== t) return e < t ? "Long" : "Short";
  return null;
};

export function EditStock({ getData, setShow, editData }) {
  const adminStore = useSelector((state) => state.adminReducer);
  const alert = useAlert();

  const [loader, setLoader] = useState(false);
  const [inputData, setInputData] = useState({ video: "" });
  const [isRecording, setIsRecording] = useState(false);
  const [selectedImg, setSelectedImg] = useState([]);
  const [selectedPDF, setSelectedPDF] = useState(null);
  const [tradeType, setTradeType] = useState(null);
  const [stockTrade, setStockTrade] = useState(INITIAL_TRADE);
  const [forexTrade, setForexTrade] = useState(INITIAL_TRADE);

  const handleStockChange = (e) => {
    const updated = { ...stockTrade, [e.target.name]: e.target.value };
    if (e.target.name === "entryPrice" || e.target.name === "takeProfit") {
      if (e.target.name === "takeProfit" && !e.target.value) {
        updated.positionType = "Long";
      } else {
        const pos = autoPositionType(updated.entryPrice, updated.takeProfit);
        if (pos) updated.positionType = pos;
      }
    }
    setStockTrade(updated);
  };
  const handleForexChange = (e) => {
    const updated = { ...forexTrade, [e.target.name]: e.target.value };
    if (e.target.name === "entryPrice" || e.target.name === "takeProfit") {
      if (e.target.name === "takeProfit" && !e.target.value) {
        updated.positionType = "Long";
      } else {
        const pos = autoPositionType(updated.entryPrice, updated.takeProfit);
        if (pos) updated.positionType = pos;
      }
    }
    setForexTrade(updated);
  };
  const handleTradeTypeChange = (type) => { setTradeType(type); setStockTrade(INITIAL_TRADE); setForexTrade(INITIAL_TRADE); };

  const handleSubmit = async () => {
    try {
      if (tradeType) {
        const activeTrade = tradeType === "stock" ? stockTrade : forexTrade;
        if (activeTrade.currency && (!activeTrade.marginUsedUSDT || Number(activeTrade.marginUsedUSDT) <= 0)) {
          alert.error("Balance Used (USD) must be greater than 0");
          return;
        }
      }
      setLoader(true);
      const formData = {
        _id: editData?._id,
        description: inputData?.description,
        video: inputData?.video || "",
        pdfFile: inputData?.pdfFile || "",
        imageTitle: inputData?.imageTitle || "",
        imageFormat: inputData?.imageFormat || "",
        tradeType: tradeType || null,
        stockTrade: tradeType === "stock" ? stockTrade : null,
        forexTrade: tradeType === "forex" ? forexTrade : null,
      };

      const signalResponse = await api.stocksEdit(formData);
      // console.log(signalResponse);

      if (signalResponse?.success) {
        alert.success("Stock edit successfully");
        setInputData({ video: "" });
        setTradeType(null);
        setStockTrade(INITIAL_TRADE);
        setForexTrade(INITIAL_TRADE);

        setLoader(false);
        setShow(false);
        getData();
      } else {
        setLoader(false);
        alert.error("Something went wrong");
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      alert.error("Something went wrong");
    }
  };

  const handleChange = (e) => {
    // console.log(e);
    setInputData({ ...inputData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    setInputData({
      description: editData?.description || "",
      video: editData?.video || "",
      pdfFile: editData?.pdfFile || "",
      imageTitle: editData?.imageTitle || "",
      imageFormat: editData?.imageFormat || "",
    });
    if (editData?.tradeType) {
      setTradeType(editData.tradeType);
      if (editData.tradeType === "stock" && editData.stockTrade) setStockTrade({ ...INITIAL_TRADE, ...editData.stockTrade });
      if (editData.tradeType === "forex" && editData.forexTrade) setForexTrade({ ...INITIAL_TRADE, ...editData.forexTrade });
    }
    // seed existing images into selectedImg
    if (editData?.imageTitle) {
      const names = editData.imageTitle.split(",");
      const formats = editData.imageFormat ? editData.imageFormat.split(",") : [];
      setSelectedImg(names.map((n, i) => `${process.env.REACT_APP_S3URL}/img_${n}.${formats[i] || ""}`));
    }
  }, []);

  const onFileChange = async (e) => {
    try {
      setLoader(true);
      if (!e.target.files) {
        return;
      }
      const formData = new FormData();
      // formData.append("image", e.target.files[0], e.target.files[0].name);
      for (let file of e.target.files) {
        formData.append("image", file);
      }
      const uploadRes = await api.uploadFile(formData);
      // console.log(uploadRes);
      let sImage = [];
      var imgName = uploadRes[0].split(",");
      var imgFormat = uploadRes[1].split(",");
      for (let i = 0; i < imgName.length; i++) {
        sImage.push(
          `${process.env.REACT_APP_S3URL}/img_${imgName[i]}.${imgFormat[i]}`,
        );
      }
      // append to existing instead of replacing
      setSelectedImg((prev) => [...prev, ...sImage]);
      setInputData((prev) => ({
        ...prev,
        imageTitle: prev.imageTitle ? `${prev.imageTitle},${uploadRes[0]}` : uploadRes[0],
        imageFormat: prev.imageFormat ? `${prev.imageFormat},${uploadRes[1]}` : uploadRes[1],
      }));
      setLoader(false);
    } catch (e) {
      alert.error("File upload failed");
      setLoader(false);
      console.log(e.message);
    }
  };

  const removeImage = (index) => {
    const names = inputData.imageTitle ? inputData.imageTitle.split(",") : [];
    const formats = inputData.imageFormat ? inputData.imageFormat.split(",") : [];
    names.splice(index, 1);
    formats.splice(index, 1);
    setInputData((prev) => ({ ...prev, imageTitle: names.join(","), imageFormat: formats.join(",") }));
    // rebuild selectedImg from updated names/formats
    const newImgs = names.map((n, i) => `${process.env.REACT_APP_S3URL}/img_${n}.${formats[i]}`);
    setSelectedImg(newImgs);
  };

  const onPDFChange = async (e) => {
    try {
      setLoader(true);

      const formData = new FormData();
      formData.append("pdf", e.target.files[0], e.target.files[0].name);
      const uploadRes = await api.uploadPDF(formData);
      // console.log(uploadRes);
      setSelectedPDF(`${process.env.REACT_APP_S3URL}/${uploadRes}`);
      setInputData({
        ...inputData,
        pdfFile: `${uploadRes}`,
      });
      setLoader(false);
    } catch (e) {
      alert.error("File upload failed");
      setLoader(false);
      console.log(e.message);
    }
  };

  return (
    <>
      <div className="row mx-0 drivers-row">
        <div className="col-xl-6 col-md-7  d-flex justify-content-between pr-0">
          <h4 className="color-dark fs-17 dib font-weight-bold mr-5">
            Edit Stock Updates
          </h4>
        </div>
      </div>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10  bg-white border-transparent py-3 ">
          <div className="descMainPost">

            {/* ── Trade Details ── */}
            <div className="form-section mb-3">
              <div className="form-section-header">
                <div className="section-title">
                  <h3 className="section-title-text">
                    <i className="fas fa-chart-line me-2"></i>Trade Details (Optional)
                  </h3>
                  <p className="section-subtitle">Attach structured trade data to this post</p>
                </div>
                {tradeType && (
                  <div className="section-status">
                    <span className="status-badge status-active">
                      {tradeType === "stock" ? "📈 Stock" : "🌍 Forex"}
                    </span>
                  </div>
                )}
              </div>

              <div className="trade-type-toggle">
                <button type="button" className={`trade-type-btn ${tradeType === "stock" ? "active-spot" : ""}`} onClick={() => handleTradeTypeChange("stock")}>
                  <i className="fas fa-chart-bar me-2"></i>Stock
                </button>
                <button type="button" className={`trade-type-btn ${tradeType === "forex" ? "active-futures" : ""}`} onClick={() => handleTradeTypeChange("forex")}>
                  <i className="fas fa-globe me-2"></i>Forex
                </button>
                {tradeType && (
                  <button type="button" className="trade-type-btn trade-type-clear" onClick={() => setTradeType(null)}>
                    <i className="fas fa-times me-2"></i>Clear
                  </button>
                )}
              </div>

              {tradeType === "stock" && (
                <div className="trade-fields-container trade-fields-spot">
                  <div className="trade-fields-badge"><i className="fas fa-chart-bar"></i> Stock Trade</div>
                  <div className="trade-grid">
                    <div className="trade-field"><label className="trade-label">Ticker</label><input type="text" name="currency" className="trade-input" placeholder="e.g. APLD, NVDA" value={stockTrade.currency} onChange={handleStockChange} /></div>
                    <div className="trade-field"><label className="trade-label">Entry Price</label><input type="number" name="entryPrice" className="trade-input" placeholder="e.g. 27.22" value={stockTrade.entryPrice} onChange={handleStockChange} /></div>
                    <div className="trade-field"><label className="trade-label">Take Profit (Target)</label><input type="number" name="takeProfit" className="trade-input" placeholder="e.g. 31.20" value={stockTrade.takeProfit} onChange={handleStockChange} /></div>
                    <div className="trade-field"><label className="trade-label">Stop Loss</label><input type="number" name="stopLoss" className="trade-input" placeholder="e.g. 25.50" value={stockTrade.stopLoss} onChange={handleStockChange} /></div>
                    <div className="trade-field"><label className="trade-label">Balance Used (USD)</label><input type="number" name="marginUsedUSDT" className="trade-input" placeholder="e.g. 500" value={stockTrade.marginUsedUSDT} onChange={handleStockChange} /></div>
                    <div className="trade-field"><label className="trade-label">Position Type</label><select name="positionType" className="trade-input trade-select" value={stockTrade.positionType} onChange={handleStockChange}><option value="Long">Long</option><option value="Short">Short</option><option value="Spot">Spot</option></select></div>
                    <div className="trade-field"><label className="trade-label">Status</label>
                      <select name="status" className="trade-input trade-select" value={stockTrade.status} onChange={handleStockChange}>
                        <option value="Open">Open</option><option value="Closed">Closed</option><option value="TP Hit">TP Hit</option><option value="SL Hit">SL Hit</option>
                      </select>
                    </div>
                    <div className="trade-field"><label className="trade-label">PNL (USDT)</label><input type="number" name="pnlUSDT" className="trade-input" placeholder="e.g. 320" value={stockTrade.pnlUSDT} onChange={handleStockChange} /></div>
                    <div className="trade-field"><label className="trade-label">ROI (%)</label><div className="trade-input-suffix"><input type="number" name="roiPercent" className="trade-input" placeholder="e.g. 6.4" value={stockTrade.roiPercent} onChange={handleStockChange} /><span className="suffix-label">%</span></div></div>
                  </div>
                </div>
              )}

              {tradeType === "forex" && (
                <div className="trade-fields-container trade-fields-futures">
                  <div className="trade-fields-badge futures-badge"><i className="fas fa-globe"></i> Forex Trade</div>
                  <div className="trade-grid">
                    <div className="trade-field"><label className="trade-label">Pair</label><input type="text" name="currency" className="trade-input" placeholder="e.g. GBP/USD, XAU/USD" value={forexTrade.currency} onChange={handleForexChange} /></div>
                    <div className="trade-field"><label className="trade-label">Entry Price</label><input type="number" name="entryPrice" className="trade-input" placeholder="e.g. 1.2955" value={forexTrade.entryPrice} onChange={handleForexChange} /></div>
                    <div className="trade-field"><label className="trade-label">Take Profit (TP)</label><input type="number" name="takeProfit" className="trade-input" placeholder="e.g. 1.2865" value={forexTrade.takeProfit} onChange={handleForexChange} /></div>
                    <div className="trade-field"><label className="trade-label">Stop Loss (SL)</label><input type="number" name="stopLoss" className="trade-input" placeholder="e.g. 1.3020" value={forexTrade.stopLoss} onChange={handleForexChange} /></div>
                    <div className="trade-field"><label className="trade-label">Balance Used (USD)</label><input type="number" name="marginUsedUSDT" className="trade-input" placeholder="e.g. 500" value={forexTrade.marginUsedUSDT} onChange={handleForexChange} /></div>
                    <div className="trade-field"><label className="trade-label">Position Type</label><select name="positionType" className="trade-input trade-select" value={forexTrade.positionType} onChange={handleForexChange}><option value="Long">Long</option><option value="Short">Short</option><option value="Spot">Spot</option></select></div>
                    <div className="trade-field"><label className="trade-label">Status</label>
                      <select name="status" className="trade-input trade-select" value={forexTrade.status} onChange={handleForexChange}>
                        <option value="Open">Open</option><option value="Closed">Closed</option><option value="TP Hit">TP Hit</option><option value="SL Hit">SL Hit</option>
                      </select>
                    </div>
                    <div className="trade-field"><label className="trade-label">PNL (USDT)</label><input type="number" name="pnlUSDT" className="trade-input" placeholder="e.g. 200" value={forexTrade.pnlUSDT} onChange={handleForexChange} /></div>
                    <div className="trade-field"><label className="trade-label">ROI (%)</label><div className="trade-input-suffix"><input type="number" name="roiPercent" className="trade-input" placeholder="e.g. 0.40" value={forexTrade.roiPercent} onChange={handleForexChange} /><span className="suffix-label">%</span></div></div>
                  </div>
                </div>
              )}
            </div>
            {/* ── End Trade Details ── */}

            <div className="form-group mb-3">
              <ReactQuill
                placeholder="Add description"
                modules={Editor}
                theme="snow"
                value={inputData.description}
                onChange={(e) => setInputData({ ...inputData, description: e })}
              />
            </div>

            <div className="form-group mb-3">
              <textarea
                name="video"
                id=""
                className="form-control"
                onChange={handleChange}
                value={inputData?.video}
                placeholder="Add Video Iframe"
              ></textarea>
            </div>
          </div>
          <div className="form-group mb-3 fileUpload-modal">
            <label>
              <input
                name="file"
                onChange={onFileChange}
                accept="image/*"
                type={"file"}
                multiple
              />
              <img src={add} />
            </label>
          </div>

          <div className="uploadedImage" style={{ display: "block" }}>
            {selectedImg.length > 0 ? (
              <>
                <div style={{ marginBottom: 6, fontSize: 13, fontWeight: 600 }}>Uploaded Images ({selectedImg.length})</div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                  {selectedImg.map((val, key) => (
                    <div key={key} style={{ position: "relative", display: "inline-block" }}>
                      <img className="img_sel" src={val} alt={key + 1} style={{ maxWidth: 100, borderRadius: 6 }} />
                      <button
                        onClick={() => removeImage(key)}
                        style={{ position: "absolute", bottom: 2, right: 2, background: "rgba(0,0,0,0.6)", color: "#fff", border: "none", borderRadius: "50%", width: 20, height: 20, cursor: "pointer", fontSize: 13, lineHeight: 1, display: "flex", alignItems: "center", justifyContent: "center", zIndex: 10 }}
                      >×</button>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <span style={{ color: "#aaa", fontSize: 13 }}>No images uploaded</span>
            )}
          </div>
          <div>Upload PDF or Word File</div>
          <div className="form-group mt-0 mb-3 fileUpload-modal">
            <label>
              <input
                name="file"
                onChange={onPDFChange}
                // accept="application/pdf"
                accept=".pdf,.doc,.docx"
                type={"file"}
              />
              {selectedPDF == null && <img src={add} />}
              {selectedPDF && (
                <a href={selectedPDF} download={inputData?.pdfFile}>
                  File Uploaded
                </a>
              )}
            </label>
          </div>

          <div className="sendMailBtn mt-3">
            <button
              onClick={handleSubmit}
              className="btn-dark"
              disabled={isRecording}
            >
              Submit
            </button>
          </div>
        </div>
      </div>

      {loader && (
        <div className="seekoLoader">
          <div className="loader">
            <img src={Logo} alt="loader" />
          </div>
        </div>
      )}
    </>
  );
}

var Editor = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image", "video"],
    ["clean"],
  ],
  clipboard: {
    // toggle to add extra line breaks when pasting HTML:
    matchVisual: false,
  },
};
